import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DataEnvService } from '../shared/sl-data/data-env.service';

interface Tab {
  label: string;
  component: string;
  requiresSuperAdmin?: boolean;
}

@Component({
  selector: 'app-admin-settings',
  templateUrl: './admin-settings.component.html',
  styleUrls: ['./admin-settings.component.scss']
})
export class AdminSettingsComponent implements OnInit {
  actionInProgress$ = new BehaviorSubject<boolean>(false);

  private allTabs: Tab[] = [
    { label: 'General', component: 'general' },
    { label: 'SMS Settings', component: 'sms' },
    { label: 'AI Settings', component: 'ai', requiresSuperAdmin: true }
  ];

  tabs: Tab[] = [];

  constructor(private dataEnv: DataEnvService) {}

  async ngOnInit(): Promise<void> {
    await this.dataEnv.setComFromCurrentUser();
    this.dataEnv.hasRole$('super-admin', true).subscribe(isSuperAdmin => {
      this.tabs = this.allTabs.filter(tab => !tab.requiresSuperAdmin || isSuperAdmin);
    });
  }
} 